// Pointages d'heures : tâches proposées et conversions d'une durée.

export const TASKS = [
  'Préparation supports', 'Peinture', 'Façade', 'Sol souple', 'Parquet',
  'Vitrification', 'Résine', 'Plafond tendu', 'Déplacement',
  'Approvisionnement', 'SAV', 'Nettoyage', 'Autre',
];

export const DEFAULT_HOURS = 8.75; // 8h45, durée journalière courante

// Conversions entre le décimal envoyé à l'API (8.75) et l'input HTML
// type="time" (« 08:45 ») — plus naturel à saisir qu'un nombre d'heures.
export const hoursToTimeStr = (hours) => {
  const total = Math.round(hours * 60);
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const timeStrToHours = (value) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(value || '');
  if (!m) return 0;
  return parseInt(m[1], 10) + parseInt(m[2], 10) / 60;
};

// « 8 h 45 », « 17 h » : une durée lisible.
export const formatHours = (hours) => {
  const total = Math.round((hours || 0) * 60);
  const h = Math.floor(total / 60);
  const m = total % 60;
  return m ? `${h} h ${String(m).padStart(2, '0')}` : `${h} h`;
};

// « jeu. 18 sept. » : une date lisible d'un coup d'œil sur un téléphone.
// Découpée à la main plutôt que passée à new Date('2026-09-18'), qui serait
// comprise comme minuit UTC et pourrait afficher la veille.
export const formatDay = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
  if (!m) return iso || '';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
};
